export const LANGUAGES = ["en", "fr", "de", "es", "it", "nl", "pt", "pl"] as const;

export type Language = (typeof LANGUAGES)[number];

// Core routes without language prefixe
export const ROUTES = {
  home: ["/"],
  homeBf: ["/home-bf"],
  pricing: [
    "/pricing",
    "/tarifs",
    "/precios",
    "/prezzi",
    "/preise",
    "/prijzen",
    "/wycena",
    "/preco"
  ],
  pricingBf: ["/pricing-bf"],
  team: ["/team", "/equipo", "/squadra", "/mannschaft", "/ekipa", "/equipa"],
  affiliate: [
    "/affiliate-program",
    "/affiliation",
    "/programa-afiliados",
    "/programma-di-affiliazione",
    "/affiliat-programm",
    "/partnerprogramma",
    "/afiliacja-programu",
    "/programa-de-afiliados"
  ],
  linkedinProspection: [
    "/feature/linkedin-prospecting",
    "/fonctionnalite/prospection-linkedin",
    "/funcionalidad/prospeccion-linkedin",
    "/funzionalita/prospezione-linkedin",
    "/funktion/prospektion-linkedin",
    "/functie/linkedin-prospecting",
    "/funkcjonalnosc/poszukiwani-linkedin",
    "/funcionalidade/prospecao-linkedin"
  ],
  coldEmailing: [
    "/feature/cold-email",
    "/fonctionnalite/cold-email",
    "/funcionalidad/cold-email",
    "/funzionalita/cold-email",
    "/funktion/cold-email",
    "/functie/cold-email",
    "/funkcjonalnosc/cold-email",
    "/funcionalidade/cold-email"
  ],
  emailFinder: [
    "/feature/email-finder",
    "/fonctionnalite/email-finder",
    "/funcionalidad/email-finder",
    "/funzionalita/email-finder",
    "/funktion/email-finder",
    "/functie/email-finder",
    "/funkcjonalnosc/email-finder",
    "/funcionalidade/email-finder"
  ],
  inbox: [
    "/feature/linkedin-messaging",
    "/fonctionnalite/messagerie-linkedin",
    "/funcionalidad/mensajeria-linkedin",
    "/funzionalita/messaggeria-linkedin",
    "/funktion/linkedin-messaging",
    "/functie/linkedin-messaging",
    "/funkcjonalnosc/wiadomosci-linkedin",
    "/funcionalidade/mensagens-do-linkedin"
  ],
  connexion: ["/connexion"],
  desktopSignupSuccess: ["/oauth-success-desktop"],
  mobileSignupSuccess: ["/oauth-success-mobile"],
  newsletter: ["/newsletter"],
  termsConditions: [
    "/terms-conditions",
    "/conditions-generales",
    "/terminos-y-condiciones",
    "/termini-e-condizioni",
    "/allgemeine-geschaftsbedingungen",
    "/algemene-voorwaarden",
    "/regulamin",
    "/termos-e-condicoes"
  ],
  termsOfUse: [
    "/terms-of-use",
    "/conditions-utilisation",
    "/condiciones-de-uso",
    "/condizioni-uso",
    "/nutzungsbedingungen",
    "/gebruiksvoorwaarden",
    "/warunki-uzytkowania",
    "/termos-de-utilizacao"
  ],
  useOfData: [
    "/use-of-data",
    "/utilisation-donnees",
    "/uso-de-datos",
    "/utilizzo-dei-dati",
    "/verwendung-von-daten",
    "/gerbruik-van-gegevens",
    "/wykorzystanie-danych",
    "/utilizacao-dos-dados"
  ],
  legalNotices: [
    "/legal-notice",
    "/mentions-legales",
    "/aviso-legal",
    "/note-legali",
    "/rechtliche-hinweise",
    "/wettelijke-vermeldingen",
    "/informacje-prawne"
  ]
};
